/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const approveDataSchema = z.object({ approved: z.literal(true) });

export const approveCollectionTriageClipResponseSchema = createApiResponseSchema(
  approveDataSchema,
) as z.ZodSchema<IAPI<{ approved: true }>>;

export type IApproveCollectionTriageClipResponse = IAPI<{ approved: true }>;
